<template>
	<div class="groups-options">
		<h2>Options</h2>
		<div class="groups-options-items-container">
			<div v-if="groupName" class="groups-options-item">
				<span>Group name</span>
				<h3>{{groupName}}</h3>
			</div>
			<div class="groups-options-item">
				<span>Created</span>
				<h3 v-if="dateCreated !== null">{{dateCreated.toDate() | formatTimestampLong}}</h3>
			</div>
			<div class="groups-options-item">
				<span>Members ({{users.length}})</span>
				<div class="users-list-container">
					<users-list :users="users" :admin="admin" :from="componentName"></users-list>
				</div>
			</div>
		</div>
		<div class="danger-options">
			<div v-if="!showDeleteOptions && !showLeaveOptions && !showSearch">
				<a
					v-if="!showDeleteOptions && isAdmin"
					class="delete-button"
					@click="showDeleteOptions = !showDeleteOptions"
				>
					<ion-icon name="trash"></ion-icon>Delete group
				</a>
				<a
					v-if="!showLeaveOptions && users.length > 2"
					class="delete-button"
					@click="showLeaveOptions = !showLeaveOptions"
				>
					<ion-icon name="ios-close"></ion-icon>Leave group
				</a>
				<!-- <button v-if="isAdmin"
                    type="button"
                    class="add-user-button"
                    @click="showSearch = !showSearch">
                    <ion-icon name="add"></ion-icon>
                    Add user
				</button>-->
			</div>
			<div v-if="showDeleteOptions || showLeaveOptions || showSearch">
				<div v-if="showDeleteOptions" class="delete-options">
					<span class="delete-info">Are you sure you want to delete this group?</span>
					<div>
						<button class="delete-button" @click="$emit('deleteGroup')">Yes</button>
						<button @click="showDeleteOptions = !showDeleteOptions">No</button>
					</div>
				</div>
				<div v-if="showLeaveOptions" class="delete-options">
					<span class="delete-info">Are you sure you want to leave this group?</span>
					<div>
						<button class="delete-button" @click="sendMessage">Yes</button>
						<button @click="showLeaveOptions = !showLeaveOptions">No</button>
					</div>
				</div>
				<div v-if="showSearch" class="delete-options">
					<!-- <groups-search></groups-search> -->
				</div>
			</div>
		</div>
		<div class="messages">
			<!-- <p v-if="isAdmin" class="stackng-note">Admins cannot leave groups</p> -->
			<p v-if="users.length <= 2" class="stackng-note">You cannot leave a group with 2 or less members</p>
		</div>
	</div>
</template>

<script>
import UsersList from "../../users/userView/UsersList.vue";
import { db } from "../../../resources/firebase";
import firebase from "firebase/app";

export default {
	data() {
		return {
			componentName: "groups-options",
			showDeleteOptions: false,
			showLeaveOptions: false,
			showSearch: false
		};
	},
	props: {
		users: {
			type: Array,
			required: true
		},
		groupName: {
			type: String
		},
		admin: {
			type: String
		},
		dateCreated: {
			type: Object
		},
		groupID: {
			type: String
		}
	},
	components: {
		UsersList
	},
	computed: {
		isAdmin() {
			return this.$store.state.user.authUser.uid === this.admin;
		}
	},
	methods: {
		sendMessage() {
			const authUser = this.$store.state.user.authUser.uid;

			db.collection("test_groups")
				.doc(this.groupID)
				.collection("messages")
				.add({
					type: "leave",
					senderID: authUser,
					sender: {
						firstName: this.$store.state.user.user.firstName,
						lastName: this.$store.state.user.user.lastName,
						username: this.$store.state.user.user.username
					},
					dateCreated: Date.now()
				})
				.then(docRef => {
					db.collection("test_groups")
						.doc(this.groupID)
						.collection("messages")
						.doc(docRef.id)
						.update({
							id: docRef.id
						})
						.then(() => {
							this.$emit("leaveGroup");
						})
						.catch(error => {
							// console.log(error);
							throw new Error(error);
						});
				})
				.catch(error => {
					// console.log(error);
					throw new Error(error);
				});
		}
	}
};
</script>

<style scoped>
h2 {
	font-weight: bold;
	width: 100%;
	text-align: center;
	padding-bottom: 15px;
	/* margin-bottom: 15px; */
	border-bottom: 1px solid #111;
}

.delete-button {
	font-size: 13px;
	padding: 5px;
	border-radius: 5px;
}

.delete-button {
	margin-right: 5px;
}

.users-list-container {
	position: relative;
	max-height: 270px;
	overflow: auto;
}

h3 {
	text-align: right;
	font-size: 13px;
}

.groups-options-item {
	display: grid;
	grid-template-columns: 20% 80%;
	padding-top: 15px;
	padding-bottom: 15px;
	border-bottom: 1px solid #111;
	align-items: center;
}

.groups-options-item span {
	font-size: 11px;
	color: #b7b7b7;
}

.delete-info {
	padding-top: 10px;
	padding-bottom: 10px;
	display: block;
	text-align: center;
	color: #b7b7b7;
	font-size: 11px;
}

.delete-options {
	margin: auto;
}

.delete-options button {
	padding: 5px 10px;
}

.delete-options button:last-of-type,
.add-user-button {
	font-size: 13px;
	padding: 5px 10px;
	border-radius: 5px;
}

.add-user-button {
	border: none;
	vertical-align: unset;
	font-weight: normal;
}

.danger-options {
	text-align: center;
	margin-top: 10px;
	display: flex;
	justify-content: center;
	align-items: center;
}

.danger-options ion-icon {
	font-size: 15px;
	vertical-align: middle;
}

.messages {
	text-align: center;
	margin-top: 10px;
}

/* .stackng-note {
        text-align: center;
    } */
</style>



// WEBPACK FOOTER //
// src/components/groups/groupsMessage/GroupsMessageOptions.vue